import { render, staticRenderFns } from "./MatchResultsServerSports.vue?vue&type=template&id=46efc82e&scoped=true"
import script from "./MatchResultsServerSports.vue?vue&type=script&lang=js"
export * from "./MatchResultsServerSports.vue?vue&type=script&lang=js"
import style0 from "./MatchResultsServerSports.vue?vue&type=style&index=0&id=46efc82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46efc82e",
  null
  
)

export default component.exports